// src/data/constants.js
export const IDB_NAME = 'pdf-storage';
export const ISTORE_NAME = 'pdfs';
export const IKEY_NAME = 'lastFile';